import { graphqlDynamic } from "react-apollo-dynamic-query"
import { connect } from "react-redux"
import gql from "graphql-tag"
import LongestGapCards from "."
import moment from "moment"
import PropTypes from "prop-types"

const generateQuery = ({ entityType }) => {
  return gql`

    query longestGapCards (
        $entityId: ID!
        $startAt: String!, 
        $endAt: String!
    ) {
      entity: ${entityType}(id: $entityId) {
        id
        users {
          id
          name
          shiftAssignments: shiftAssignments(startAt: $startAt, endAt: $endAt) {
            id
            longestGap
            startsAt
            endsAt
            beginningShiftChange {
              duration
            }
            endingShiftChange {
              duration
            }
          }
        }
      }
    }
  `
}

const LongestGapCardsWithApollo = graphqlDynamic(generateQuery, {
  options: ({ entityId, startAt, endAt }) => ({
    variables: {
      entityId,
      startAt,
      endAt,
    },
  }),
  props: ({ data: { loading, error, entity } }) => {
    if (error) {
      throw error
    }
    if (!loading) {
      if (!entity) {
        throw Error("404")
      }

      const users = entity.users
      const longestGapArr = []
      const longestDurationArr = []
      users.forEach(element => {
        /* istanbul ignore else */
        if (element.shiftAssignments.length > 0) {
          element.shiftAssignments.forEach(element => {
            longestGapArr.push(element.longestGap)
            if (
              element.beginningShiftChange !== null &&
              element.beginningShiftChange.duration > 0
            ) {
              longestDurationArr.push(element.beginningShiftChange.duration)
            }
            if (
              element.endingShiftChange !== null &&
              element.endingShiftChange.duration > 0
            ) {
              longestDurationArr.push(element.endingShiftChange.duration)
            }
          })
        }
      })
      return {
        data: [longestGapArr, longestDurationArr],
      }
    }
    const longestDurationArr = []
    const longestGapArr = []
    return { loading, data: [longestGapArr, longestDurationArr] }
  },
})(LongestGapCards)

const LongestGapCardsWithData = connect(
  ({
    dateRange: { startDate, endDate },
    bsrCompliance: { bsrCompliance },
  }) => ({
    startAt: moment(startDate),
    endAt: moment(endDate),
    bsrCompliance: bsrCompliance,
  })
)(LongestGapCardsWithApollo)

LongestGapCardsWithData.propTypes = {
  entityId: PropTypes.string.isRequired,
  entityType: PropTypes.oneOf(["facility", "department", "unit"]).isRequired,
}

export default LongestGapCardsWithData
